import React from "react";
import { ErrorState } from "../Types";
import { Error } from "./Error";
import { LabelContext } from "./LabelContext";
import styles from "./Label.scss";

export interface ErrorSummaryProps {
    id: string
    error?: string | ErrorState<any> | null;
}

export const ErrorScope: React.FC<ErrorSummaryProps> = (props) => {
    return <div className={styles["au-fieldset"]}>
        {props.error && (
            <span className={styles["au-error-text"]} id={`${props.id}-hint`}>
                <Error error={props.error} />
            </span>
        )}
        <LabelContext.Provider
            value={{
                state: props.error ? "invalid" : undefined,
                describedBy:
                props.error ? `${props.id}-hint` :  undefined,
            }}
        >
            {props.children}
        </LabelContext.Provider>
    </div>
}